// Dados da seção "Sobre": versão, commit do build e o que mudou. Função pura, sem I/O: quem lê
// os arquivos é src/http/sobre.ts (servidor), e o navegador usa o mesmo normalizador com a
// resposta de GET /api/sobre. Um campo fora do formato cai no padrão, para um build.json torto
// não derrubar a API nem a página.

export interface Sobre {
  /** Versão do package.json. */
  versao: string;
  /** Commit curto do build (git rev-parse --short HEAD), ou 'desconhecido'. */
  commit: string;
  /** Quando o build foi feito (ISO), ou vazio. */
  data: string;
  /** Mensagens dos últimos commits, da mais nova para a mais velha. Sem autor nem e-mail. */
  mudou: string[];
}

export const MUDOU_MAX = 20;
const TEXTO_MAX = 200;

const objeto = (valor: unknown): Record<string, unknown> => (valor && typeof valor === 'object' && !Array.isArray(valor) ? (valor as Record<string, unknown>) : {});

/** Texto curto e sem espaços nas pontas; fora do tipo ou vazio vira o padrão. */
function texto(valor: unknown, padrao: string): string {
  if (typeof valor !== 'string') return padrao;
  const limpo = valor.trim().slice(0, TEXTO_MAX);
  return limpo || padrao;
}

/** Commit: só hexadecimal de 4 a 40 caracteres; qualquer outra coisa é desconhecido. */
export function commitValido(valor: unknown): string {
  return typeof valor === 'string' && /^[0-9a-f]{4,40}$/i.test(valor) ? valor : 'desconhecido';
}

/** Normaliza o que veio de build.json ou da API: campos ausentes ou tortos caem no padrão. */
export function normalizaSobre(bruto: unknown): Sobre {
  const o = objeto(bruto);
  const mudou = Array.isArray(o.mudou)
    ? o.mudou
        .filter((linha): linha is string => typeof linha === 'string')
        .map((linha) => linha.trim().slice(0, TEXTO_MAX))
        .filter(Boolean)
        .slice(0, MUDOU_MAX)
    : [];
  return {
    versao: texto(o.versao, 'desconhecida'),
    commit: commitValido(o.commit),
    data: texto(o.data, ''),
    mudou,
  };
}
